import React from 'react';

import {
  ProductContext,
  useProductDetailContext,
} from '~/techstyle-shared/react-components';

import OutfitItem from '../OutfitItem/OutfitItem';

const OutfitItems = () => {
  const { bundleProducts } = useProductDetailContext();
  return (
    <>
      {bundleProducts?.map((product, index) => (
        <ProductContext key={index} product={product} productIndex={index}>
          <OutfitItem />
        </ProductContext>
      ))}
    </>
  );
};

export default OutfitItems;
